import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, MinusIcon } from 'lucide-react';
const rows = [{
  label: 'Who designs your piece',
  chain: 'A pattern from a catalogue',
  sinclairs: "James, or a jeweller he's trained"
}, {
  label: "Where it's made",
  chain: 'Often manufactured overseas',
  sinclairs: 'On our bench in Ardross'
}, {
  label: 'Diamond guidance',
  chain: 'Sales staff working to targets',
  sinclairs: 'Honest advice — including what not to pay for'
}, {
  label: 'Before you see it',
  chain: 'Hope it looks right in person',
  sinclairs: 'CAD model + wearable 3D resin proof'
}, {
  label: 'If it needs adjusting later',
  chain: 'Send-away service · weeks',
  sinclairs: 'We re-size it ourselves · usually days'
}, {
  label: 'Aftercare',
  chain: 'Paid service plan',
  sinclairs: 'Lifetime cleaning + inspection · included'
}, {
  label: 'Who you talk to next year',
  chain: 'Whoever is on shift',
  sinclairs: 'The same family. Same workshop. Same bench.'
}];
export function Comparison() {
  return <section className="section-padding paper-texture" data-id="element-29">
      <div className="container-custom" data-id="element-30">
        <div className="max-w-3xl mx-auto text-center mb-14" data-id="element-31">
          <span className="eyebrow" data-id="element-32">The honest comparison</span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-[2.75rem] font-medium leading-[1.1] text-balance" data-id="element-33">
            Why families quietly leave the chain stores{' '}
            <span className="italic text-gold-dark" data-id="element-34">
              and come to us instead.
            </span>
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="max-w-5xl mx-auto bg-surface border border-gold/20 overflow-hidden" data-id="element-35">
          {/* Header row */}
          <div className="grid grid-cols-1 md:grid-cols-[1.2fr_1fr_1fr] border-b border-gold/15" data-id="element-36">
            <div className="hidden md:block p-5 md:p-6" data-id="element-37"></div>
            <div className="p-5 md:p-6 border-l border-gold/15 bg-background/50" data-id="element-38">
              <p className="brand-mark text-[0.65rem] uppercase text-muted" data-id="element-39">
                A chain jeweller
              </p>
            </div>
            <div className="p-5 md:p-6 border-l border-gold/15 bg-primary text-white" data-id="element-40">
              <p className="brand-mark text-[0.65rem] uppercase text-gold-light" data-id="element-41">
                Sinclairs · Est. 1947
              </p>
            </div>
          </div>

          {/* Rows */}
          {rows.map((row, index) => <div key={index} className={`grid grid-cols-1 md:grid-cols-[1.2fr_1fr_1fr] border-b border-gold/10 last:border-b-0`} data-id="element-42">
              <div className="p-5 md:p-6 bg-paper/30 md:bg-transparent" data-id="element-43">
                <p className="brand-mark text-[0.6rem] uppercase text-muted md:hidden mb-1" data-id="element-44">
                  Topic
                </p>
                <p className="font-serif text-base md:text-lg text-primary leading-snug" data-id="element-45">
                  {row.label}
                </p>
              </div>
              <div className="p-5 md:p-6 md:border-l border-gold/15 flex items-start gap-3" data-id="element-46">
                <MinusIcon className="w-4 h-4 text-muted shrink-0 mt-1" data-id="element-47" />
                <p className="text-sm text-secondary leading-snug" data-id="element-48">
                  {row.chain}
                </p>
              </div>
              <div className="p-5 md:p-6 md:border-l border-gold/15 bg-paper/40 flex items-start gap-3" data-id="element-49">
                <CheckIcon className="w-4 h-4 text-gold-dark shrink-0 mt-1" strokeWidth={3} data-id="element-50" />
                <p className="text-sm text-primary font-medium leading-snug" data-id="element-51">
                  {row.sinclairs}
                </p>
              </div>
            </div>)}
        </motion.div>

        <p className="text-center text-sm text-muted italic mt-8 max-w-2xl mx-auto" data-id="element-52">
          We don't have anything against chain stores. We just believe
          meaningful jewellery deserves to be made by someone who'll still be
          here in twenty years to look after it.
        </p>
      </div>
    </section>;
}